import { render, staticRenderFns } from "./NavbarFooter.vue?vue&type=template&id=a5afc76c&scoped=true&"
import script from "./NavbarFooter.vue?vue&type=script&lang=js&"
export * from "./NavbarFooter.vue?vue&type=script&lang=js&"
import style0 from "./NavbarFooter.vue?vue&type=style&index=0&id=a5afc76c&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a5afc76c",
  null
  
)

export default component.exports